import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ChevronDown, LogOut } from "lucide-react";
import { useKycLogout } from "./use-kyc-logout";
import type { ReactNode } from "react";

const KycShell = ({
  firstName,
  children,
}: {
  // Undefined while the user is still loading.
  firstName?: string;
  children: ReactNode;
}) => {
  const logout = useKycLogout();
  return (
    <div className="text-dark-text-400">
      <div className="relative flex min-h-dvh">
        {/* Same side panel as the login and signup pages. */}
        <div className="fixed inset-y-0 left-0 hidden h-screen lg:block">
          <img
            src="/images/auth-img.webp"
            className="h-full w-auto"
            alt="Save money in fractional digital gold."
          />
          <img
            src="/images/auth-icons.png"
            className="absolute bottom-10 left-8 z-10 w-40"
            alt=""
          />
        </div>
        <div
          className="fixed inset-y-0 left-0 hidden h-screen lg:block"
          style={{
            background: "linear-gradient(180deg, #0B1828 0%, #05070E 100%)",
          }}
        >
          <img
            src="/images/auth-image2.webp"
            className="h-full w-auto"
            alt="Welcome to the KrypKard Global Payment Ecosystem"
          />
        </div>
        <div className="invisible hidden h-screen lg:block">
          <img src="/images/auth-img.webp" className="h-full w-auto" alt="" />
        </div>
        <div className="relative flex grow flex-col bg-[#FBFFFF] px-5 py-6 lg:px-12 lg:py-8">
          <div className="flex items-center justify-between lg:justify-end">
            <img
              src="/images/full-logo-dark.svg"
              alt="KrypKard"
              className="w-28 lg:hidden"
            />
            {firstName ? (
              <DropdownMenu>
                <DropdownMenuTrigger className="flex cursor-pointer items-center gap-2 rounded text-sm font-medium outline-none">
                  <span className="flex size-8 items-center justify-center rounded-full bg-black/5">
                    {firstName.charAt(0).toUpperCase()}
                  </span>
                  {firstName}
                  <ChevronDown className="text-dark-text-300 size-4" />
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="min-w-36">
                  <DropdownMenuItem
                    className="cursor-pointer gap-2"
                    onSelect={logout}
                  >
                    <LogOut className="size-4" />
                    Logout
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            ) : (
              <div className="flex animate-pulse items-center gap-2">
                <span className="size-8 rounded-full bg-black/5" />
                <span className="h-4 w-16 rounded bg-black/5" />
              </div>
            )}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default KycShell;
